import scss from './EmptyState.module.scss';

import React from 'react';

import classNames from 'classnames';

export enum EmptyStateSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export function EmptyState({
  image: Image,
  heading,
  headingLevel = 3,
  style,
  className,
  description,
  size = EmptyStateSize.Medium,
  children,
}: {
  image: () => React.JSX.Element;
  heading: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  description: string | React.JSX.Element;
  style?: React.CSSProperties;
  className?: string;
  size?: EmptyStateSize;
  children?: React.ReactNode;
}) {
  const Heading = `h${headingLevel}` as const;
  return (
    <div
      style={style}
      className={classNames(
        scss.comp,
        size === EmptyStateSize.Small && scss.small,
        size === EmptyStateSize.Medium && scss.medium,
        size === EmptyStateSize.Large && scss.large,
        className
      )}
    >
      <Image />
      <Heading className={scss.heading}>{heading}</Heading>
      {typeof description === 'string' ? (
        <p className={scss.description}>{description}</p>
      ) : (
        <div className={scss.description}>{description}</div>
      )}
      {children && <div className={scss.button}>{children}</div>}
    </div>
  );
}
